import React from 'react'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { AutomationId } from 'utils/automationUtil'
import {
  StyledContainer,
  StyledContentContainer,
  StyledHeaderContainer,
  StyledHeaderLeft,
  StyledHeaderRight,
  StyledIconContainer,
  StyledContent,
  StyledActionContainer
} from './index.css'

type CompactVocSoundbiteFrameProps = {
  dateItem: React.ReactNode
  domainIcon: React.ReactElement
  headerInfo: React.ReactElement
  internalContents: React.ReactNode
  avatar: React.ReactNode
  actionItems: React.ReactNode
  serialNumber: number
}

const CompactVocSoundbiteFrame = ({
  headerInfo,
  dateItem,
  domainIcon,
  internalContents,
  avatar,
  actionItems,
  serialNumber
}: CompactVocSoundbiteFrameProps) => {
  const theme = useDisplayTheme() as Theme

  return (
    <StyledContainer
      mode={theme}
      data-testid={`${AutomationId.compactSoundbiteDefaultFrame.post}-${serialNumber}`}>
      {avatar}
      <StyledContentContainer>
        <StyledHeaderContainer>
          <StyledHeaderLeft>{headerInfo}</StyledHeaderLeft>
          <StyledHeaderRight mode={theme}>
            {dateItem}
            <StyledIconContainer>{domainIcon}</StyledIconContainer>
          </StyledHeaderRight>
        </StyledHeaderContainer>
        <StyledContent mode={theme}>{internalContents}</StyledContent>
        {actionItems && <StyledActionContainer>{actionItems}</StyledActionContainer>}
      </StyledContentContainer>
    </StyledContainer>
  )
}

export default CompactVocSoundbiteFrame
